namespace Areas.RecordsRetention.Create {
    "use strict";

    export function createSummary() {
        const form = $("#SummaryForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();

        if (result.isValid != null) {
            sendRequest(`/RecordsRetention/Create/Post/`, JSON.stringify(newData), "POST");
        }
    }
}